export default __webpack_public_path__ + "static/media/logo.54546991.png";